import { Component, Input } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() size: string = '75px';
  @Input() color: string = 'var(--action-primary, #88517c)';
  @Input() display: string = 'block';
  @Input() thickness: string = '10px';
}
